// extracted by mini-css-extract-plugin
export default {"container":"serviceCreate_container__Dag4k","card":"serviceCreate_card__0LVgS"};